/* eslint-disable import/no-unresolved,react/prop-types */
import React, { ComponentType, useCallback } from 'react';
import { Link as LinkIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { formatNumbers } from 'utilities';
import { WithLinkProps } from './WithLink.props';

const isIconVisible = true;

// eslint-disable-next-line react/display-name
const withLink = (WrappedComponent: ComponentType<any>) => (props: WithLinkProps) => {
  const navigate = useNavigate();

  const openLink = useCallback(() => {
    if (props.cell?.link?.url) {
      navigate(props.cell.link.url);
    }
  }, [navigate, props.cell]);

  if (isEmpty(props.cell.link)) {
    return <WrappedComponent {...props} />;
  }

  return (
    <div className="link">
      <span className="value-viewer link__value">
        {props.cell.component ? (
          React.cloneElement(props.cell.component, { cell: props.cell }, null)
        ) : (
          <Link to={props.cell.link.url}>{formatNumbers(props.cell as any)}</Link>
        )}
      </span>
      {isIconVisible && (
        <div>
          <Tooltip
            title={props.cell.link.tooltip ?? ''}
            placement="top"
            arrow
            disableHoverListener={!props.cell.link.tooltip}>
            <IconButton onClick={openLink} size="small">
              <LinkIcon className="link__icon" fontSize="small" color="secondary" />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

withLink.defaultProps = {
  cell: {
    value: null,
    key: null,
  },
};

withLink.propTypes = {
  cell: PropTypes.object.isRequired,
};

export default withLink;
